import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeResourceUrl',
})
export class SafeResourceUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(base64: string): SafeResourceUrl {
    if (base64.startsWith('data:')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(base64);
    }

    const mimeType = this.getMimeType(base64);
    const fullDataUrl = `data:${mimeType};base64,${base64}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(fullDataUrl);
  }

  private getMimeType(base64: string): string {
    const header = base64.substring(0, 10);

    if (header.startsWith('JVBER')) return 'application/pdf';
    if (header.startsWith('/9j')) return 'image/jpeg';
    if (header.startsWith('iVBOR')) return 'image/png';
    if (header.startsWith('R0lGOD')) return 'image/gif';

    return 'application/octet-stream';
  }
}
